export const handleDownloadDocument = (documentUrl: string) => {
  const a = document.createElement('a');
  a.href = documentUrl;
  a.click();
};
